"use strict";

import React from 'react';
import ReactDOM from 'react-dom';

import './shared/polyfill';
import './css/main.scss';
import './images/logo.png';
import Panel from './react-components/panel';

ReactDOM.render(<Panel/>, document.getElementById("root"));